var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComprehensiveSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 201,
    viewBox: "0 0 400 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_5372)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.617188,
    width: 400,
    height: 200,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 90.6172V90.6172C275.926 90.6172 282.289 99.2768 279.623 107.795L257.479 178.536C254.517 187.998 261.585 197.617 271.5 197.617V197.617",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.888 105.422C92.9179 96.5668 101.242 90.6172 110.601 90.6172H267C257.188 90.6172 248.432 96.7769 245.117 106.012L217.365 183.317C214.07 192.495 205.368 198.617 195.616 198.617H58L89.888 105.422Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 115.617H203",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 133.617H196",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85 179.676C178.344 187.588 182.334 195.619 189.231 198.867H46.5524C33.6306 198.867 24.5991 186.08 28.92 173.902L36.5606 152.367H189.501L180.85 179.676Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.911 197.617H271.52C282.218 197.617 291.625 190.536 294.584 180.255L319.652 93.1486C323.332 80.3639 313.736 67.6172 300.432 67.6172H180.482L173 90.6172",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 172.617H333C335.209 172.617 337 174.408 337 176.617V194.617C337 196.826 335.209 198.617 333 198.617H325",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337 176.617H341.223C343.707 176.617 346.157 177.196 348.378 178.306L353.338 180.786C353.773 181.004 354.253 181.117 354.74 181.117H363.5C365.157 181.117 366.5 182.46 366.5 184.117V184.117C366.5 185.774 365.157 187.117 363.5 187.117H352.097C351.715 187.117 351.348 187.269 351.078 187.539L349.5 189.117",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.5 193.117H342L353.105 196.935C356.214 198.003 359.634 197.67 362.477 196.02L380.803 185.391C382.074 184.654 382.634 183.112 382.132 181.73V181.73C381.524 180.057 379.612 179.265 377.998 180.018L366 185.617",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 146.617V166.617",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "3 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 150.617V166.617",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "3 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 166.617V142.617H384V142.117L373 130.617L362 142.117V142.617H368V144.117",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 166.617V142.617",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "3 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 166.617V146.617H360V146.117L352 138.617L344 146.117V146.617H348V147.617",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 166.617V150.617H339V150.117L333 144.617L327 150.117V150.617H330V152.117",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5 32.6172H365.843C378.549 32.6172 388.034 44.3107 385.413 56.7433L373 115.617",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373,
    cy: 115.617,
    r: 6,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 139.617L34 124.617",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 151.617L18 130.617",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.0001,
    cy: 15.1017,
    rx: 31.4576,
    ry: 14.1017,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.9152,
    cy: 25.9495,
    rx: 26.0339,
    ry: 8.67797,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.8813,
    y: 12.9326,
    width: 52.0678,
    height: 13.0169,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.8813,
    y: 12.9326,
    width: 52.0678,
    height: 13.0169,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.8813,
    y: 12.9326,
    width: 52.0678,
    height: 13.0169,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.8813,
    y: 12.9326,
    width: 52.0678,
    height: 13.0169,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.9152,
    cy: 12.9319,
    rx: 26.0339,
    ry: 8.67797,
    fill: "#304FF2",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-25-inside-1_198_5372",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8813 43.313V56.3236C59.8813 61.1163 71.5371 65.0016 85.9152 65.0016C100.293 65.0016 111.949 61.1163 111.949 56.3236V43.3066C111.949 48.0992 100.293 51.9842 85.9152 51.9842C71.5438 51.9842 59.8922 48.1026 59.8813 43.313Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8813 43.313V56.3236C59.8813 61.1163 71.5371 65.0016 85.9152 65.0016C100.293 65.0016 111.949 61.1163 111.949 56.3236V43.3066C111.949 48.0992 100.293 51.9842 85.9152 51.9842C71.5438 51.9842 59.8922 48.1026 59.8813 43.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8813 43.313L61.3813 43.3096L58.3813 43.313H59.8813ZM111.949 43.3066H113.449L110.449 43.3064L111.949 43.3066ZM58.3813 43.313V56.3236H61.3813V43.313H58.3813ZM58.3813 56.3236C58.3813 58.1784 59.5104 59.7066 60.9988 60.8796C62.504 62.0658 64.5892 63.0685 67.0322 63.8829C71.9338 65.5167 78.6098 66.5016 85.9152 66.5016V63.5016C78.8425 63.5016 72.5017 62.5438 67.9808 61.0368C65.7126 60.2807 63.9852 59.4135 62.8557 58.5233C61.7093 57.6198 61.3813 56.8652 61.3813 56.3236H58.3813ZM85.9152 66.5016C93.2207 66.5016 99.8967 65.5167 104.798 63.8829C107.241 63.0685 109.326 62.0658 110.832 60.8796C112.32 59.7066 113.449 58.1784 113.449 56.3236H110.449C110.449 56.8652 110.121 57.6198 108.975 58.5233C107.845 59.4135 106.118 60.2807 103.85 61.0368C99.3288 62.5438 92.9879 63.5016 85.9152 63.5016V66.5016ZM113.449 56.3236V43.3066H110.449V56.3236H113.449ZM110.449 43.3064C110.449 43.848 110.121 44.6027 108.975 45.5062C107.845 46.3963 106.118 47.2635 103.849 48.0196C99.3285 49.5265 92.9877 50.4842 85.9152 50.4842V53.4842C93.2205 53.4842 99.8964 52.4994 104.798 50.8657C107.241 50.0514 109.326 49.0487 110.831 47.8625C112.32 46.6896 113.449 45.1615 113.449 43.3068L110.449 43.3064ZM85.9152 50.4842C78.8459 50.4842 72.5076 49.5273 67.9871 48.0216C65.7191 47.2661 63.9911 46.3995 62.8603 45.5097C61.7124 44.6064 61.3826 43.8513 61.3813 43.3096L58.3814 43.3164C58.3856 45.1694 59.5162 46.6957 61.0052 47.8673C62.5112 49.0524 64.5964 50.0542 67.0391 50.8678C71.94 52.5003 78.6132 53.4842 85.9152 53.4842V50.4842Z",
    fill: "black",
    mask: "url(#path-25-inside-1_198_5372)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8813 28.1264V41.1371C59.8813 45.9298 71.5371 49.815 85.9152 49.815C100.293 49.815 111.949 45.9298 111.949 41.1371V28.1201C111.948 32.9126 100.293 36.7976 85.9152 36.7976C71.5438 36.7976 59.8922 32.916 59.8813 28.1264Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8813 28.1264V41.1371C59.8813 45.9298 71.5371 49.815 85.9152 49.815C100.293 49.815 111.949 45.9298 111.949 41.1371V28.1201C111.948 32.9126 100.293 36.7976 85.9152 36.7976C71.5438 36.7976 59.8922 32.916 59.8813 28.1264Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8813 28.1264V41.1371C59.8813 45.9298 71.5371 49.815 85.9152 49.815C100.293 49.815 111.949 45.9298 111.949 41.1371V28.1201C111.948 32.9126 100.293 36.7976 85.9152 36.7976C71.5438 36.7976 59.8922 32.916 59.8813 28.1264Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8813 28.1264V41.1371C59.8813 45.9298 71.5371 49.815 85.9152 49.815C100.293 49.815 111.949 45.9298 111.949 41.1371V28.1201C111.948 32.9126 100.293 36.7976 85.9152 36.7976C71.5438 36.7976 59.8922 32.916 59.8813 28.1264Z",
    fill: "#304FF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_5372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "white",
    transform: "translate(0 0.617188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehensiveSolution);
export default __webpack_public_path__ + "static/media/comprehensive_solution.e1bb2b5a713af31455d7abf29417b4f8.svg";
export { ForwardRef as ReactComponent };